import React, { useState } from 'react';
import serviceBanner from '../assets/service.png';
import wholesaleService from '../services/wholesaleService';

const Services = () => {
  const [formData, setFormData] = useState({
    companyName: '',
    contactName: '',
    email: '',
    phone: '',
    products: '',
    message: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await wholesaleService.submitInquiry(formData);
    alert(result.message);
    if (result.success) {
      setFormData({
        companyName: '',
        contactName: '',
        email: '',
        phone: '',
        products: '',
        message: ''
      });
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const wholesaleInfo = wholesaleService.getWholesaleInfo();

  return (
    <div style={{ padding: '2rem 0' }}>
      <div className="container">
        {/* Banner Image */}
        <div style={{ marginBottom: '3rem', textAlign: 'center' }}>
          <img 
            src={serviceBanner} 
            alt="Star Tidbits Services" 
            style={{ 
              width: '100%', 
              maxWidth: '1200px', 
              height: 'auto', 
              borderRadius: '12px',
              boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)'
            }} 
          />
        </div>

        <h1 style={{ marginBottom: '2rem', textAlign: 'center' }}>Our Services</h1>
        
        {/* Company Description */}
        <div className="card" style={{ marginBottom: '3rem', backgroundColor: 'white' }}>
          <p>
            Star Tidbits supplies more than 35 types of tidbits, including the popular Muruku, peanuts, 
            and Indian sweets to major supermarkets and most of the retail shops in Singapore. During 
            traditional festivals, such as Diwali and the Tamil New Year, Star Tidbits will take orders 
            for traditional Indian sweets and Muruku items.
          </p>
          <p>
            We also supply tidbits for other special occasions such as open houses, temple functions, 
            weddings, company parties, etc. In addition, we maintain proper hygiene and quality standards 
            during each stage of preparation until they are packed and dispatched. We provide 24-hour 
            service to our customers and also take orders through email.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-3" style={{ marginBottom: '3rem' }}>
          <div className="card" style={{ backgroundColor: 'white' }}>
            <h3>🏪 Retail Supply</h3>
            <p>Supplying to major supermarkets and retail shops across Singapore with our 35+ varieties of authentic tidbits.</p>
          </div>
          
          <div className="card" style={{ backgroundColor: 'white' }}>
            <h3>🎉 Festival Orders</h3>
            <p>Special orders for traditional festivals like Diwali and Tamil New Year featuring authentic Indian sweets and Muruku.</p>
          </div>
          
          <div className="card" style={{ backgroundColor: 'white' }}>
            <h3>🎊 Event Catering</h3>
            <p>Custom orders for House warming, temple functions, weddings, company parties, and special occasions.</p>
          </div>
        </div>
        
        {/* Shipping Information */}
        <div className="card" style={{ backgroundColor: 'white', textAlign: 'left', marginBottom: '3rem' }}>
          <h3>🚚 Shipping & Pickup</h3>
          <p style={{ fontSize: '1.1rem', fontWeight: '500' }}>Enjoy FREE Shipping on Orders Over S$200! For purchases under S$200, conveniently pick up in-store.</p>
        </div>

        
      </div>
    </div>
  );
};

export default Services;